export class PrizmInvalidMonthException extends Error {
  constructor(month: number) {
    super(`Invalid month: ${month}`);
  }
}
